import React from "react";
import Header from "../../components/Header/Header";
import s from "./BalanceList.module.scss";
import Table, { ColumnsType } from "antd/es/table";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { Link } from "react-router-dom";
import { Tooltip } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { getTransactionsHistory } from "../../redux/BillingSlice";
import Footer from "../../components/Footer/Footer";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import { useTranslation } from "react-i18next";

interface TableType {
  number: number;
  name: string;
  company: string;
  country: string;
  balance: number;
}

const BalanceList = () => {
  const dispatch: AppDispatch = useDispatch();
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const partners = useSelector(
    (state: RootState) => state.user.usersList?.partners
  );
  const columns: ColumnsType<TableType> = [
    {
      title: "№",
      dataIndex: "number",
      width: 20,
      align: "center",
    },

    {
      title: t("ФИО"),
      dataIndex: `name`,
      width: 600,
    },
    {
      title: t("Компания"),
      dataIndex: `company`,
      width: 600,
    },

    {
      title: t("Страна регистрации компании"),
      dataIndex: `country`,
      width: 600,
    },

    {
      title: t("Баланс"),
      dataIndex: `balance`,
      width: 200,
      render: (text) => <div className={s.font}>{text}</div>,
    },
    {
      title: t("История"),
      dataIndex: `history`,
      width: 50,
      align: "center",
    },
  ];
  return (
    <div>
      {width > 985 ? <Header /> : <MobileHeader />}
      <div className={s.table}>
        <div className={s.h2}>{t("Список партнеров")}</div>
        <Table
          columns={columns}
          dataSource={partners?.map((it, index) => ({
            number: index + 1,
            name: it?.full_name,
            company: it?.company_name,
            country: it?.registered_country,
            balance: it?.current_balance,
            history: (
              <Link
                to={"/balance"}
                className={s.edit}
                onClick={() =>
                  dispatch(getTransactionsHistory({ user_id: it?.id }))
                }
              >
                <Tooltip title={t("История")} key={1}>
                  <EditOutlined />
                </Tooltip>
              </Link>
            ),
          }))}
          pagination={false}
        />
      </div>
      <Footer />
    </div>
  );
};

export default BalanceList;
